// extracted by mini-css-extract-plugin
export default {"subtable":"sub_table_subtable__2wNzJ"};